import React from "react";
import { useStyles } from "../../../assets/jss/PraisoTable";
import DateTime from "../../DateTime/DateTime";
import CustomBox from "../CustomBox/CustomBox";
import { useTranslation } from "react-i18next";
import CustomTypography from "../CustomTypography/CustomTypography";
import autoGenerated from "../../../assets/images/autoGenerated.svg";
import { EventStatus } from "../../../config/app-globals.enum";


export const CustomDate = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <>
      {props && props.date ? (
        <CustomBox className={classes.tableCellValue}>
          <div className={classes.eventDateValue}>
            <DateTime inputDate={props.date} returnFormat="ddd" />,{" "}
            <DateTime inputDate={props.date} returnFormat="DD MMM YYYY" />
          </div>
          <div className={classes.eventTimeValue}>
            <DateTime inputDate={props.date} returnFormat="hh:mm:ss a" />
            {props?.eventStatus === EventStatus.SYSTEM_GENERATED_EVENT ?
              <div className={classes.autoGeneratedDiv}>
                <img src={autoGenerated} className={classes.autoGenerated} />
                <CustomTypography className={classes.autoGeneratedText}>{t("AUTO_GENERATED")}</CustomTypography>
              </div>
              : null}
          </div>
        </CustomBox>
      ) : null
      }
    </>
  );
};
